import FileGrantsIpcRouter, {
  type AttachedFile,
  type AttachFilesPayload,
  type CreateFileSandboxPayload,
  type FileAttachSupport,
  type FileGrantsIpcRouterType,
  type FileSandboxIdPayload,
  type GrantSandboxPathPayload,
  type RevokeSandboxPathPayload,
  type SaveScratchFilePayload,
} from '@shared/ipc/routers/FileGrantsIpc.router'
import type { FileGrantSummary, FileSandboxSummary } from '@shared/file-grants/file-grant-types'

class FileGrantsIpcRenderer extends FileGrantsIpcRouter implements FileGrantsIpcRouterType {
  async listSandboxes(): Promise<Array<FileSandboxSummary>> {
    return this.exec('listSandboxes')
  }

  async listGrants(payload: FileSandboxIdPayload): Promise<Array<FileGrantSummary>> {
    return this.exec('listGrants', payload)
  }

  async describeAttachSupport(): Promise<FileAttachSupport> {
    return this.exec('describeAttachSupport')
  }

  async createSandbox(payload: CreateFileSandboxPayload): Promise<FileSandboxSummary> {
    return this.exec('createSandbox', payload)
  }

  async deleteSandbox(payload: FileSandboxIdPayload): Promise<void> {
    return this.exec('deleteSandbox', payload)
  }

  async grantPath(payload: GrantSandboxPathPayload): Promise<FileGrantSummary | null> {
    return this.exec('grantPath', payload)
  }

  async attachFiles(payload: AttachFilesPayload): Promise<Array<AttachedFile>> {
    return this.exec('attachFiles', payload)
  }

  async revokePath(payload: RevokeSandboxPathPayload): Promise<void> {
    return this.exec('revokePath', payload)
  }

  async saveScratchFile(payload: SaveScratchFilePayload): Promise<string> {
    return this.exec('saveScratchFile', payload)
  }
}

export default new FileGrantsIpcRenderer()
